/**
 * Maestro de prueba del portal local.
 * Pon el id del caso que quieres ver; null usa el maestro del login.
 * En build de producción este valor se ignora.
 */

export const maestroIdOverride: number | null = null;
// export const maestroIdOverride: number | null = 89; // maestro con adeudos de cuotas.
// export const maestroIdOverride: number | null = 49598; // maestro en servicio.
// export const maestroIdOverride: number | null = 60095; // maestro en servicio con préstamo y ahorro.
// export const maestroIdOverride: number | null = 18950; // maestro jubilado con adeudos.
